import { render, staticRenderFns } from "./FormTemporary.vue?vue&type=template&id=7068c3f8&scoped=true&"
import script from "./FormTemporary.vue?vue&type=script&lang=js&"
export * from "./FormTemporary.vue?vue&type=script&lang=js&"
import style0 from "./FormTemporary.vue?vue&type=style&index=0&id=7068c3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068c3f8",
  null
  
)

export default component.exports